import React from "react"
import {Link} from "react-router-dom"

function NavbarTest(props){

    const navbarStyle ={
        height: 'auto',
        marginTop: '0vh',
        marginBottom: '0vh',
        padding: '5px',
        paddingTop: '2vh',
        backgroundColor: '#012782',
      }
      
      const ulStyle ={
        listStyleType: 'none',
        margin: '0',
        padding: '0',
        overflow: 'hidden',
        
      }
      
      const linkStyle ={
        float: 'left',
        margin: '5px',
        textDecoration: 'none',
        display: 'block',
        color: 'white',
        textAlign: 'center',
        padding: '2vh',
        fontSize: '2.5vh',
      }

    return(
        <div style={navbarStyle} className= "container-fluid text-white" >
            <div className="row justify-content-center align-items-center">
                <div className="col-12">

            
                    <nav className="navbar navbar-expand-lg navbar-dark header">
                        <Link className="navbar-brand logo text-white" to="/">Molecular Virology Lab</Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
                                aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"
                                id="header-slide-button">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div id="navbarNavDropdown" className="collapse navbar-collapse">
                            <ul  className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <Link to="/Research" className="nav-link nav-underline text-white" >
                                Research
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/members"  className="nav-link nav-underline text-white" >
                                Members
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/publications" className="nav-link nav-underline text-white" >
                                Publications
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact" className="nav-link nav-underline text-white">
                                Contact
                                </Link>
                            </li>
                            </ul>
                        </div>
                    </nav>


                </div>
            </div>
        </div>
    )
}



export default NavbarTest